import {
    LOGIN_ERROR,
    LOGIN_SUCCESS,
    EMAIL_CHANGE,
    PASSWORD_CHANGE,
    CLEAR_AUTH_ERROR,
    AUTH_TOKEN_CHANGE,
} from './constants';


const defaultState = {
    authError: null,
    authEmail: '',
    password: '',
    authToken: null,
};

const auth = (state = defaultState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state, password: '',
            };
        case LOGIN_ERROR:
            return { ...state, password: '', authError: 'Login failed' };
        case EMAIL_CHANGE:
            return { ...state, authEmail: action.authEmail };
        case PASSWORD_CHANGE:
            return { ...state, password: action.password };
        case AUTH_TOKEN_CHANGE:
            return { ...state, authToken: action.authToken };
        case CLEAR_AUTH_ERROR:
            return { ...state, authError: action.authError };

        default:
            return state;
    }
};

export default auth;



// WEBPACK FOOTER //
// ./src/containers/common/auth/reducer.js